import { AdjudicationTriageReasons, PV1TriageReasons } from '@truepill/tpos-types'

export const isRefillTooSoonReason = (reason?: string): boolean =>
  reason === PV1TriageReasons.RefillTooSoon || reason === AdjudicationTriageReasons.RefillTooSoonRejection
